export default "__VITE_ASSET__Hoz8srJx__"